var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisualEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#A9CC13",
    fillOpacity: 0.3,
    stroke: "#A9CC13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6191 22.6177V26.0792H17.0715L27.2537 15.87L23.8014 12.4085L13.6191 22.6177ZM29.9236 13.1931C30.2826 12.8331 30.2826 12.2515 29.9236 11.8915L27.7693 9.73155C27.4103 9.37155 26.8303 9.37155 26.4712 9.73155L24.7864 11.4208L28.2388 14.8823L29.9236 13.1931Z",
    fill: "#A9CC13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7543 12.2331H9.47656V30.2331H28.8099V17.808L26.7385 18.3546V28.1562H11.548V14.31H20.1789L20.7543 12.2331Z",
    fill: "#A9CC13"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualEdit);
export default __webpack_public_path__ + "static/media/visual_edit.94497aa3.svg";
export { ForwardRef as ReactComponent };